import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {Router} from "@angular/router";
import {WindowRefService, StripeService, NotifComparatorService, TrackingService} from '@app/core';
import {Subscription} from 'rxjs/Subscription';
import {IViewresaPush} from '@app/shared';

const GTMCheckoutProcess = {
    step_3: 3,
    step_4 : 4,
    payment_method: 'Stripe'
}
@Component({
    selector: 'app-stripe-form',
    templateUrl: './stripe-form.component.html',
    styleUrls: ['./stripe-form.component.scss']
})
export class StripeFormComponent implements OnInit, OnDestroy {
    private readonly _ROUTE_VIEWRESA = '/checkprice/viewresa';
    @Input() dataCardInfo: any;
    @Input() ruid: string;
    @ViewChild('cardInfo') cardInfo: ElementRef;
    error: string;
    isLoadingCardPay: boolean = false;
    confiStripe: any;
    notifSubscription: Subscription;

    constructor(private winRef: WindowRefService, private stripeService: StripeService, private router: Router, private notifComparatorService: NotifComparatorService,private trackingService: TrackingService) {}

    ngOnInit() {
        this.loadStripe();
        this.notifSubscription = this.notifComparatorService.watch().subscribe((data: IViewresaPush) => {
            console.log('push IViewresaPush ->', data);
            if (data.viewresa) {
                if(data.viewresa.hasError !== "0") {
                    alert("Error server !");
                } else {
                    if (data.viewresa.ruid == this.ruid) {
                        console.log('redirection by push')
                        this.router.navigate([this._ROUTE_VIEWRESA, this.ruid]);
                    }
                }
            }
        });
    }

    ngOnDestroy() {
        this.notifSubscription.unsubscribe();
    }

    onSubmit() {
        this.isLoadingCardPay = true;
        if (this.confiStripe) {
            let promise = this.stripeService.pay(this.confiStripe);
            this.error = "";
            promise.then((result) => {
                this.isLoadingCardPay = false;
                if (result.error) {
                    this.error = result.error.message;
                } else {
                    this.orderComplete(this.confiStripe);
                    try {this.trackingService.chekoutProcess(GTMCheckoutProcess.step_3,GTMCheckoutProcess.payment_method);} catch (error) {} 
                }
            })
        } else {

        }
    }

    /**
     * Shows a success / error message when the payment is complete
     */
    private orderComplete(confiStripe) {
        confiStripe.stripe.retrievePaymentIntent(confiStripe.clientSecret).then(result => {
            let paymentIntent = result.paymentIntent;
            //TODO: requeste api validation of creation of reservation
            if (paymentIntent.status == "succeeded") {
                this.isLoadingCardPay = true;
                setTimeout(() => {
                    this.router.navigate([this._ROUTE_VIEWRESA, this.ruid]);
                    this.trackingService.chekoutProcess(GTMCheckoutProcess.step_4,null);
                    console.log('setTimeout', new Date())
                }, 60000);
            }
        });
    }

    /**
     * load js stripe
     */
    private loadStripe() {
        if (!this.winRef.nativeWindow.document.getElementById('stripe-script')) {
            var s = this.winRef.nativeWindow.document.createElement("script");
            s.id = "stripe-script";
            s.type = "text/javascript";
            s.src = "https://js.stripe.com/v3/";
            s.onload = () => {
                this.confiStripe = this.stripeService.setupElements(this.winRef.nativeWindow.window['Stripe'], this.dataCardInfo, this.cardInfo);
            }
            this.winRef.nativeWindow.document.body.appendChild(s);
        } else {
            this.confiStripe = this.stripeService.setupElements(this.winRef.nativeWindow.window['Stripe'], this.dataCardInfo, this.cardInfo);
        }
    }
}
